module.exports = __webpack_public_path__ + "img/lg_ring_r_i_1_null@2x.b3184879.png";